import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketSettingsCostNewController from 'lumen/controllers/market/settings/cost/new';
import type { CostModel } from 'lumen/routes/market/settings/cost';
import type { Transition } from 'lumen/services/transition';
import {
  setupUnsavedChangesTransitionHandler,
  type TransitionHandler,
} from 'lumen/utils/unsaved-changes-transition-handlers';

// Feature-toggle gating lives on the parent `market.settings.cost` route, whose
// `beforeModel` runs first and redirects before this route is entered.
export default class MarketSettingsCostNewRoute extends Route {
  @service declare router: Services['router'];

  #transitionHandler?: TransitionHandler;

  model(): CostModel {
    return this.modelFor('market.settings.cost') as CostModel;
  }

  resetController(
    controller: MarketSettingsCostNewController,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      this.#transitionHandler?.cleanup();
      this.#transitionHandler = undefined;
      controller.resetForm();
    }
  }

  setupController(
    controller: MarketSettingsCostNewController,
    model: CostModel,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    this.#transitionHandler = setupUnsavedChangesTransitionHandler(
      this.router,
      controller,
      'market.settings.cost.new',
    );
  }
}
